// import React, { useState, useMemo } from 'react';
// import TinderCard from 'react-tinder-card';

// const sampleData = [
//   {
//     name: 'Alice',
//     img: 'https://via.placeholder.com/300x400/FFB6C1/000000?text=Alice',
//     bio: 'Loves hiking and photography.',
//   },
//   {
//     name: 'Bob',
//     img: 'https://via.placeholder.com/300x400/87CEFA/000000?text=Bob',
//     bio: 'Coffee addict & book worm.',
//   },
//   {
//     name: 'Charlie',
//     img: 'https://via.placeholder.com/300x400/98FB98/000000?text=Charlie',
//     bio: 'Aspiring chef and travel enthusiast.',
//   },
//   {
//     name: 'Diana',
//     img: 'https://via.placeholder.com/300x400/FFDEAD/000000?text=Diana',
//     bio: 'Artist, musician and tea lover.',
//   },
// ];

// function StackCard() {
//   const [cards, setCards] = useState(sampleData);
//   const [lastDirection, setLastDirection] = useState(null);

//   const childRefs = useMemo(
//     () => cards.map(() => React.createRef()),
//     [cards]
//   );

//   const swiped = (direction, name) => {
//     console.log('Swiped ' + direction + ' on ' + name);
//     setLastDirection(direction);
//   };

//   const outOfFrame = (name) => {
//     console.log(name + ' left the screen');
//     // Remove the card from the deck
//     setCards(prev => prev.filter(card => card.name !== name));
//   };

//   const swipe = (dir) => {
//     if (cards.length) {
//       const toSwipe = childRefs[cards.length - 1].current;
//       if (toSwipe) {
//         toSwipe.swipe(dir); // programmatically trigger swipe
//       }
//     }
//   };

//   return (
//     <div className="h-full flex flex-col items-center justify-center bg-gray-100 p-4">
//       <h1 className="text-3xl font-bold mb-6">Swipe Cards Demo</h1>

//       <div className="w-full max-w-md h-96 relative">
//         {cards.map((card, index) => (
//           <TinderCard
//             ref={childRefs[index]}
//             className="absolute"
//             key={card.name}
//             onSwipe={(dir) => swiped(dir, card.name)}
//             onCardLeftScreen={() => outOfFrame(card.name)}
//             preventSwipe={['up','down']}
//           >
//             <div className="bg-white rounded-xl shadow-2xl w-full h-96 flex flex-col overflow-hidden">
//               <div 
//                 className="h-2/3 bg-cover bg-center"
//                 style={{ backgroundImage: `url(${card.img})` }}
//               />
//               <div className="p-4 flex-1 flex flex-col">
//                 <h2 className="text-2xl font-semibold mb-2">{card.name}</h2>
//                 <p className="text-gray-600 flex-1">{card.bio}</p>
//               </div>
//             </div>
//           </TinderCard>
//         ))}
//       </div>

//       {cards.length === 0 && (
//         <div className="mt-8 text-xl text-gray-500">
//           No more cards.
//         </div>
//       )}

//       <div className="mt-8 space-x-4">
//         <button
//           className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
//           onClick={() => swipe('left')}
//         >
//           Nope
//         </button>

//         <button
//           className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
//           onClick={() => swipe('right')}
//         >
//           Like
//         </button>
//       </div>

//       {lastDirection && (
//         <div className="mt-4 text-lg">
//           You swiped {lastDirection}
//         </div>
//       )}
//     </div>
//   );
// }

// export default StackCard;




// import React, { useState, useRef } from 'react';
// import { motion, useMotionValue, useTransform, AnimatePresence } from 'framer-motion';

// const sampleData = [
//   {
//     name: 'Alice',
//     img: 'https://via.placeholder.com/300x400/FFB6C1/000000?text=Alice',
//     bio: 'Loves hiking and photography.',
//   },
//   {
//     name: 'Bob',
//     img: 'https://via.placeholder.com/300x400/87CEFA/000000?text=Bob',
//     bio: 'Coffee addict & book worm.',
//   },
//   {
//     name: 'Charlie',
//     img: 'https://via.placeholder.com/300x400/98FB98/000000?text=Charlie',
//     bio: 'Aspiring chef and travel enthusiast.',
//   },
//   {
//     name: 'Diana',
//     img: 'https://via.placeholder.com/300x400/FFDEAD/000000?text=Diana',
//     bio: 'Artist, musician and tea lover.',
//   },
// ];

// function Card({ data, onSwipe }) {
//   const x = useMotionValue(0);
//   const rotate = useTransform(x, [-200, 0, 200], [-20, 0, 20]);
//   const opacity = useTransform(x, [-200, -100, 0, 100, 200], [0, 0.5, 1, 0.5, 0]);

//   const handleDragEnd = (event, info) => {
//     const offset = info.offset.x;
//     const velocity = info.velocity.x;

//     if (offset < -100 || velocity < -500) {
//       onSwipe('left', data.name);
//     } else if (offset > 100 || velocity > 500) {
//       onSwipe('right', data.name);
//     } else {
//       // snap back
//     }
//   };

//   return (
//     <motion.div
//       className="absolute w-full h-full cursor-grab"
//       style={{ x, rotate, opacity }}
//       drag="x"
//       dragConstraints={{ left: 0, right: 0 }}
//       onDragEnd={handleDragEnd}
//       whileTap={{ cursor: 'grabbing' }}
//     >
//       <div className="bg-white rounded-xl shadow-2xl w-full h-full flex flex-col overflow-hidden">
//         <div
//           className="h-2/3 bg-cover bg-center"
//           style={{ backgroundImage: `url(${data.img})` }}
//         />
//         <div className="p-4 flex-1 flex flex-col">
//           <h2 className="text-2xl font-semibold mb-2">{data.name}</h2>
//           <p className="text-gray-600 flex-1">{data.bio}</p>
//         </div>
//       </div>
//     </motion.div>
//   );
// }

// function App() {
//   const [cards, setCards] = useState(sampleData);
//   const [lastSwipe, setLastSwipe] = useState(null);

//   const handleSwipe = (direction, name) => {
//     setLastSwipe(`${name} swiped ${direction}`);
//     setCards(prev => prev.filter(card => card.name !== name));
//   };

//   return (
//     <div className="h-full flex flex-col items-center justify-center bg-gray-100 p-4">
//       <h1 className="text-3xl font-bold mb-6">Swipe Cards Demo</h1>

//       <div className="w-full max-w-md h-96 relative">
//         <AnimatePresence>
//           {cards.map((card, index) => (
//             <Card key={card.name} data={card} onSwipe={handleSwipe} />
//           ))}
//         </AnimatePresence>
//       </div>

//       {cards.length === 0 && (
//         <div className="mt-8 text-xl text-gray-500">No more cards.</div>
//       )}

//       {lastSwipe && (
//         <div className="mt-4 text-lg">{lastSwipe}</div>
//       )}
//     </div>
//   );
// }

// export default App;




import React, { useState, useRef, useCallback } from 'react';
import { motion, useMotionValue, useTransform, AnimatePresence } from 'framer-motion';

const sampleData = [
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Al-Sim.jpg',
        name: 'ALSIM AL250 FNPT II Simulator',
        bio: 'A state-of-the-art flight simulator replicating multiple aircraft types for advanced pilot training. It delivers unmatched realism, helping students master navigation, instrument, and emergency procedures safely.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Beechcraft.jpg',
        name: 'Beechcraft',
        bio: 'Renowned for its stability and durability, the Beechcraft is ideal for multi-engine and advanced flight training. Its reliable performance makes it a trusted choice for developing confident, skilled aviators.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Cessna.jpg',
        name: 'CESSNA 150',
        bio: 'The world’s most popular training aircraft, known for its reliability and ease of control. Perfect for students at every level, it provides a smooth, stable, and confidence-building flight experience.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Piper.jpg',
        name: 'Piper PA-38 Tomahawk',
        bio: 'A light training aircraft designed specifically for flight instruction. With responsive handling and simplicity, it’s perfect for beginners to build strong foundational skills.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Tecnam.jpg',
        name: 'Tecnam P2006T',
        bio: 'A modern twin-engine aircraft offering efficiency and advanced avionics for professional training. Its sleek design and fuel efficiency make it a top choice for multi-engine certification.',
    },
];

function Card({ data, onSwipe, isTop }) {
    const x = useMotionValue(0);
    const rotate = useTransform(x, [-200, 0, 200], [-20, 0, 20]);
    const opacity = useTransform(x, [-200, -100, 0, 100, 200], [0, 0.5, 1, 0.5, 0]);

    const handleDragEnd = (event, info) => {
        const offset = info.offset.x;
        const velocity = info.velocity.x;

        if (offset < -100 || velocity < -500) {
            onSwipe('left', data.name);
        } else if (offset > 100 || velocity > 500) {
            onSwipe('right', data.name);
        } else {
            // snap back: do nothing, Framer will animate back
        }
    };

    return (
        // <motion.div
        //   className="absolute w-full h-full cursor-grab"
        //   style={{ x, rotate, opacity }}
        //   drag={isTop ? "x" : false}
        //   dragConstraints={{ left: 0, right: 0 }}
        //   onDragEnd={isTop ? handleDragEnd : undefined}
        //   whileTap={isTop ? { cursor: 'grabbing' } : undefined}
        // >
        //   <div className="rounded-xl shadow-2xl w-full h-full flex flex-col overflow-hidden bg-cover"
        //   style={{ backgroundImage: `url(${data.img})` }}
        //   >
        //     <div className="p-4 flex-1 flex flex-col">
        //       <h2 className="text-2xl font-semibold mb-2">{data.name}</h2>
        //       <p className="text-gray-600 flex-1">{data.bio}</p>
        //     </div>
        //   </div>
        // </motion.div>

        <motion.div
            className="absolute w-full h-[500px] cursor-grab"
            style={{ x, rotate, opacity }}
            drag={isTop ? "x" : false}
            dragConstraints={{ left: 0, right: 0 }}
            onDragEnd={isTop ? handleDragEnd : undefined}
            whileTap={isTop ? { cursor: 'grabbing' } : undefined}
        >
            <div
                className="rounded-xl shadow-2xl w-full h-full overflow-hidden bg-cover bg-center"
                style={{ backgroundImage: `url(${data.img})` }}
            >
                <div className="flex flex-col justify-end h-full p-4 bg-gradient-to-t from-black to-transparent">
                    <h2 className="text-2xl font-semibold mb-2 text-white">{data.name}</h2>
                    <p className="text-gray-200">{data.bio}</p>
                </div>
            </div>
        </motion.div>
    );
}

function App() {
    const [cards, setCards] = useState(sampleData);
    const [lastSwipe, setLastSwipe] = useState(null);

    const handleSwipe = useCallback((direction, name) => {
        setLastSwipe(`${name} swiped ${direction}`);

        setCards(prev => {
            const remaining = prev.filter(c => c.name !== name);
            const swipedCard = prev.find(c => c.name === name);
            if (!swipedCard) return remaining;
            // Add swiped card to end to loop
            return [...remaining, swipedCard];
        });
    }, []);

    return (
        <div className="flex flex-col items-center justify-center p-4 mt-20 mb-40">
            <p className="text-3xl text-[#012D6F] font-bold mb-6">Our Fleet</p>
            <p className="text-3xl text-[#012D6F] font-bold mb-6 text-center">Meet the Fleet That <span className='text-[#E43038]'>Shapes Aviators</span></p>

            <div className="w-full max-w-xs h-96 relative">
                <AnimatePresence initial={false}>
                    {cards.slice(0, 3).map((card, index) => {
                        const isTop = index === 0;
                        // For card behind: apply slight rotation & offset
                        const offset = isTop ? {} : (index === 1 ? { rotate: -10, scale: 0.9, x: -20, y: 20, opacity: 0.8 } : { rotate: 10, scale: 0.9, x: 20, y: 20, opacity: 0.8 });
                        return (
                            <motion.div
                                key={card.name}
                                initial={{ scale: offset.scale ?? 1, x: offset.x ?? 0, y: offset.y ?? 0, rotate: offset.rotate ?? 0, opacity: offset.opacity ?? 1 }}
                                animate={{ scale: offset.scale ?? 1, x: offset.x ?? 0, y: offset.y ?? 0, rotate: offset.rotate ?? 0, opacity: offset.opacity ?? 1 }}
                                exit={{ opacity: 0, scale: 0.8 }}
                                transition={{ duration: 0.3 }}
                                className="absolute w-full h-full"
                                style={{ zIndex: cards.length - index }}
                            >
                                <Card data={card} onSwipe={handleSwipe} isTop={isTop} />
                            </motion.div>
                        );
                    })}
                </AnimatePresence>
            </div>

            {/* {lastSwipe && (
        <div className="mt-4 text-lg">{lastSwipe}</div>
      )} */}
        </div>
    );
}

export default App;
